import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/fontawesome";
import "./plugins/bootstrap-vue";
import App from "./App.vue";

//MODULES
import VueAWN from "vue-awesome-notifications";
let options = {
  position: "bottom-right",
  labels: {
    info: "Information",
    success: "Succès",
    warning: "Attention",
    alert: "Erreur",
    async: "Chargement...",
    confirm: "Attention",
    confirmOk: "Valider",
    confirmCancel: "Annuler",
  },
};
Vue.use(VueAWN, options);
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import router from "./router";
import store from "./store";
import VueLayers from "vuelayers";

import "vuelayers/lib/style.css"; // needs css-loader
import "./plugins/axios";
import "./config.js";

Vue.use(VueLayers);
Vue.config.productionTip = false;
import VueCrypt from 'vue-crypt'
Vue.use(VueCrypt)

import {
  ValidationObserver,
  ValidationProvider,
  extend
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import {
  localize
} from "vee-validate";
import fr from "vee-validate/dist/locale/fr.json";
localize("fr", fr);
// install rules
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// COMPONENTS GLOBAL
import Autocomplete from "vuejs-auto-complete";
Vue.component("autocomplete", Autocomplete);

// import component and stylesheet
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";
const datepickerOptions = {
  days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
  daysShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
  monthNames: [
    'Janvier',
    'Fevrier',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],
  colors: {
    selected: '#00a699',
    inRange: '#66e2da',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#33dacd',
    disabled: '#fff',
    hoveredInRange: '#67f6ee'
  },
  texts: {
    apply: 'Appliquer',
    cancel: 'Annuler',
    keyboardShortcuts: 'Raccourcis',
  },
  // ariaLabels: {
  //   // chooseDate: (date) => date,
  //   // chooseStartDate: (date) => `Choisir ${date} comme date de début.`,
  //   // chooseEndDate: (date) => `Choisir ${date} comme date de fin.`,
  //   // selectedDate: (date) => `Selection du ${date}`,
  //   unavailableDate: 'Date non disponible',
  //   previousMonth: 'Aller au mois précedent',
  //   nextMonth: 'Aller au mois suivant',
  //   closeDatepicker: 'Fermer le calendrier',
  //   openKeyboardShortcutsMenu: 'Ouvrir le menu des raccourcis',
  //   closeKeyboardShortcutsMenu: 'Fermer le menu des raccourcis'
  // },
  keyboardShortcuts: [{
      symbol: '↵',
      label: 'Sélectionnez la date en surbrillance',
      symbolDescription: 'Touche entrée'
    },
    {
      symbol: '←/→',
      label: 'Déplacement d\' un jour à gauche ou à droite',
      symbolDescription: 'Touche directionnel gauche ou droite'
    },
    {
      symbol: '↑/↓',
      label: 'Déplacemene d\'une semaine en haut ou en bas',
      symbolDescription: 'touche directionnel haut ou bas'
    },
    {
      symbol: 'PgUp/PgDn',
      label: 'Changer les mois',
      symbolDescription: 'touche page suivante, précédente'
    },
    {
      symbol: 'Home/End',
      label: 'Aller au dernier jour d\'une semaine',
      symbolDescription: 'touche Fin'
    },
    {
      symbol: 'Esc',
      label: 'Fermer le panneau',
      symbolDescription: 'Touche échap'
    },
    {
      symbol: '?',
      label: 'Ouvrir le panneau',
      symbolDescription: 'Raccourcis'
    }
  ],
};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

const DEFAULT_TITLE = "SUDTHD";
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const roles = to.meta.roles;

  if (requiresAuth && !store.getters["Authentification/isAuthenticated"]) {
    return next("/login");
  }

  if (store.getters["Authentification/isAuthenticated"]) {
    const userConnected = store.getters["Authentification/userConnected"];
    const needsUser =
      !userConnected ||
      typeof userConnected.id === "undefined" ||
      userConnected.id === null;
    if (needsUser) {
      try {
        const response = await Vue.axios.get(window.urlapi + "userConnected");
        if (response.data && response.data.data && typeof response.data.data.id !== "undefined") {
          await store.dispatch("Authentification/setUserConnected", response.data.data);
        }
      } catch (e) {
        /* la suite du garde-fou maintenance / rôles s'applique quand même */
      }
    }
  }

  if (roles) {
    let roleOk = false;
    if (roles.indexOf("All") !== -1) {
      roleOk = true;
    }
    const userConnected = store.getters["Authentification/userConnected"];
    if (userConnected && userConnected.roles) {
      for (let i = 0; i < userConnected.roles.length; i++) {
        if (roles.indexOf(userConnected.roles[i]) !== -1) {
          roleOk = true;
        }
      }
    }
    if (!roleOk) {
      /* comportement historique : pas de redirection explicite */
    }
  }

  const publicMaintenanceBypass = [
    "Login",
    "ForgotPassword",
    "Password",
    "Emailvalidation",
    "Maintenance",
  ];

  try {
    const m = await Vue.axios.get(window.urlapi + "maintenance/status");
    const payload = m.data && m.data.data;
    const active = !!(m.data && m.data.success && payload && payload.active);

    if (active) {
      if (publicMaintenanceBypass.indexOf(to.name) !== -1) {
        return next();
      }

      const uc = store.getters["Authentification/userConnected"];
      const isSuperAdmin =
        uc &&
        uc.roles &&
        uc.roles.indexOf("ROLE_SUPER_ADMIN") !== -1;

      if (to.name === "MaintenanceManagement" && isSuperAdmin) {
        return next();
      }

      if (to.name === "MaintenanceManagement" && !isSuperAdmin) {
        return next({ path: "/maintenance" });
      }

      return next({ path: "/maintenance" });
    }
  } catch (e) {
    /* API indisponible : on n'empêche pas la navigation */
  }

  next();
});
window.Event = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");